import React, { useContext } from "react";
import { NavLink } from 'react-bootstrap';
import { Icon, Button } from "semantic-ui-react";
import {
  Wrapper,
  Container,
  Row,
  Col,
  Contact,
  Div,
  Links,
  Ul,
  Li,
  Subscribe,
  InputGroup,
  Input,
  Form,
} from "./style";
import { ThemeContext } from "../../ThemedContext/Provider";

const Footer = () => {
  const { theme } = useContext(ThemeContext);
  return (
    <Wrapper themed={theme}>
      <Container>
        <Row>
          <Col>
            <Contact>
              <Div>
                SNITCH
              </Div>
              <Div style={{ alignItems: 'center' }}>
                <span style={{ whiteSpace: 'nowrap' }}>Follow us</span>
                <NavLink><Icon style={{ color: 'rgb(255 91 65)' }} circular name='facebook' /></NavLink>
                <NavLink><Icon style={{ color: 'rgb(255 91 65)' }} circular name='twitter' /></NavLink>
                <NavLink><Icon style={{ color: 'rgb(255 91 65)' }} circular name='whatsapp' /></NavLink>
                <NavLink><Icon style={{ color: 'rgb(255 91 65)' }} circular name='instagram' /></NavLink>
              </Div>
            </Contact>
            <p>&copy; Copyright 2021, Snitch corporation. All rights reversed.</p>
          </Col>
          <Col>
            <Links>
              <h4 style={{ borderBottom: '1px solid rgb(255 255 255 / 10%)', paddingBottom: '5px' }}>Useful Links</h4>
              <Ul style={{ margin: 0, padding: 0 }}>
                <Li>Terms Of Use</Li>
                <Li>Privacy Policy</Li>
                <Li style={{ margin: 0, paddingBottom: 0 }}>FAQ</Li>
              </Ul>
            </Links>
          </Col>
          <Col>
            <Subscribe>
              <h4 style={{ borderBottom: '1px solid rgb(255 255 255 / 10%)', paddingBottom: '5px' }}>Contact Us</h4>
              <Form>
                <InputGroup>
                  <Input type='text' placeholder='Name' />
                </InputGroup>
                <InputGroup>
                  <Input type='email' placeholder='E-Mail' />
                </InputGroup>
                <Button color='orange'><Icon name='mail outline' />Send Message</Button>
              </Form>
            </Subscribe>
          </Col>
        </Row>
      </Container>
    </Wrapper>
  );
};

export default Footer;
